module.exports={select:"Sélectionner",selected:"Sélectionné"};